import api from '__jsVueApi';

export default {
	async loadListOfDealsReview({ state, commit }) {
		commit('main/setLoad', true, { root: true });
		await axios
			.get(api.admin.dealsReviews.get, {
				params: {
					review_requested: true
				}
			})
			.then(response => {
				commit('setListOfDealsReview', response.data.results);
			})
			.catch(err => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
};
